import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { GreenchipsCredentialsInputDTORuntype, GreenchipsResponseBodyDTORuntype } from './greenchipsBackendTypes';

export const greenchipsEndpoints = {
    'GET /3rdparty/greenchips/credentials': endpoint({
        description: 'Returns credentials for Greenchips integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: GreenchipsResponseBodyDTORuntype,
    }),
    'POST /3rdparty/greenchips/credentials': endpoint({
        description: 'Uploads credentials for Greenchips API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: GreenchipsCredentialsInputDTORuntype,
        responseBody: GreenchipsResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/greenchips/credentials'],
    }),
    'PATCH /3rdparty/greenchips/credentials': endpoint({
        description: 'Updates credentials for Greenchips API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: GreenchipsCredentialsInputDTORuntype,
        responseBody: GreenchipsResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/greenchips/credentials'],
    }),
    'DELETE /3rdparty/greenchips/credentials': endpoint({
        description: 'Deletes existing credentials for Greenchips API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/greenchips/credentials'],
    }),
};
